import arrowRightDropdownItem from 'assets/svg/arrowRightDropdownItem.svg'
import React, { FC } from 'react'
import { PairItemTypes } from 'src/types'
import styled from 'styled-components'
// import { ReactComponent as IndicatorIcon } from './svg/indicator.svg'
import BadgeDropdown from '../../BadgeDropdown'

const PairItem: FC<PairItemTypes> = ({
  label,
  tickerLabel,
  // percent,
  // isPositive,
  // trendRange,
  isBadge,
  // isIndicator,
  // estimatedAmount,
  // isError,
}) => {
  return (
    <Pair key={label}>
      <Label>{label}</Label>{' '}
      <TickerLabel>
        {tickerLabel && `(${tickerLabel})`}
        {isBadge && <BadgeDropdown type={isBadge} />}
      </TickerLabel>
      <Body>
        {/* <Price $isPositive={isError?.length === 0}>{isError?.length !== 0 ? isError : `$${estimatedAmount}`}</Price> */}
        {/* <TrendRange>{trendRange}</TrendRange>
        <Percent $isPositive={isPositive}>
          {isIndicator && <IndicatorIconStyled />}
          {percent}
        </Percent> */}
      </Body>
    </Pair>
  )
}

export default PairItem

const Pair = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 0.25rem;
  /* flex-direction: column; */
  transition: color 0.2s;

  position: relative;
  height: fit-content;
  padding: 0.625rem 0.75rem;

  clear: both;
  color: ${({ theme: { colors } }) => colors.newDarkColor.softNavy};
  text-align: inherit;
  white-space: nowrap;
  line-height: 1.375;
  background-color: transparent;
  border: 0;
  transition: color 0.2s, background-color 0.2s;

  &:hover {
     {
      color: ${({ theme: { colors } }) => colors.link};
    }

    text-decoration: none;
    background-color: ${({ theme: { colors } }) => colors.white};

    &::after {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      height: 100%;
      width: 2rem;
      border-radius: 0.25rem;
      background-image: url(${arrowRightDropdownItem});
      background-repeat: no-repeat;
      background-position: center;
      background-color: ${({ theme: { colors } }) => colors.newLightColor.vividBlue};

      [dir='rtl'] & {
        left: 0;
        right: unset;
        transform: rotate(180deg);
      }
    }
  }
`
const Label = styled.h6`
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.semibold};
  font-size: 0.875rem;
  line-height: 21px;
`

const TickerLabel = styled.span`
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.normal};

  & > span {
    margin-inline-start: 0.25rem;
  }
`

const Body = styled.div`
  display: flex;
  align-items: center;

  @media ${({ theme }) => theme.device.lg} {
  }
`

// const Price = styled.div<{ $isPositive: boolean }>`
//   font-weight: 400;
//   font-size: 14px;
//   line-height: 21px;
//   opacity: 0.8;
//   margin-inline-end: auto;

//   color: ${({ $isPositive }) => ($isPositive ? '#31BA99' : '#ff7777')};
// `
// const TrendRange = styled.div`
//   font-weight: 400;
//   font-size: 14px;
//   line-height: 21px;
//   color: #324875;
//   opacity: 0.8;
// `
// const Percent = styled.div<{ $isPositive: boolean }>`
//   padding-inline-start: 9px;
//   font-size: 14px;
//   font-weight: 600;
//   margin-inline-end: 30px;

//   color: ${({ $isPositive }) => ($isPositive ? '#31BA99' : '#ff7777')};
// `

// const IndicatorIconStyled = styled(IndicatorIcon)`
//   margin-inline-end: 4px;
//   margin-top: 7px;
// `
